import { AxiosError } from "axios";

export function getErrorMessage(error: Error | AxiosError | string | unknown): string {
  if (error instanceof AxiosError || error instanceof Error) {
    return error.message;
  }
  return String(error);
}
